import React from 'react';
import { ReactRenderer, type RendererProps } from '@atlaskit/renderer';
import type { RenderFn } from '@atlassian/forge-ui-types';

export type AdfRendererProps = RendererProps;

export const AdfRenderer = (props: Parameters<RenderFn>[0]) => {
	const adfRendererProps = props.forgeDoc.props as AdfRendererProps;

	return <ReactRenderer {...adfRendererProps} />;
};
